var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Header',{attrs:{"openAuthPanel":_vm.openAuthPanel,"openAuthPanelAndRegister":_vm.openAuthPanelAndRegister},on:{"auth-panel-closed":function($event){_vm.openAuthPanel = false, _vm.openAuthPanelAndRegister = false}}}),_c('Auth')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }